const classPrefix = 'promo-banner';
const dataPrefix = 'data-promo-banner';

const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    promoBanner($container);
}

function promoBanner(container) {


    init();

    function init(){

    }

}
